class SwatchDetails extends HTMLElement {
  static observedAttributes = ["product-handle"];

  constructor() {
    super();
  }

  connectedCallback() {}

  disconnectedCallback() {}

  _load(handle) {
    fetch(`${window.productUrl(handle)}?section_id=swatch-details`)
      .then((res) => res.text())
      .then((html) => {
        this.innerHTML = html;

        this.closest(".swatch-modal__inner-wrapper")?.scroll({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "product-handle" && newValue !== null) {
      this._load(newValue);
    }
  }
}

if (!customElements.get("swatch-details")) {
  customElements.define("swatch-details", SwatchDetails);
}
